<template>
    <div class="mb-40">
        <settings-heading
            :title="$t('settings.documents.title')"
            :description="$t('settings.documents.description')"
        />

        <div class="mt-24 grid grid-cols-1 gap-24 sm:grid-cols-2">
            <document-block
                v-for="(document, index) in documents"
                :key="index"
                :icon="document.icon"
                :link="document.link"
                :title="document.title"
                class="rounded-6 border border-primary-5 shadow-sm text-center hover:border-primary-20 group"
            ></document-block>
        </div>
    </div>
</template>

<script>
import SvgIcon from '../../components/ui/SvgIcon';
import SimpleButton from '../../components/ui/SimpleButton';
import DocumentBlock from '../../components/settings/DocumentBlock';
import SettingsHeading from "../../components/ui/SettingsHeading.vue";

export default {
    components: {SettingsHeading, DocumentBlock, SimpleButton, SvgIcon},
    data: function () {
        return {
            documents: [
                {
                    title: this.$t('general.privacy_declaration'),
                    icon: 'privacy-declaration',
                    link: this.$t('general.privacy_link'),
                },
                {
                    title: this.$t('general.terms_and_conditions'),
                    icon: 'terms-and-conditions',
                    link: this.$t('general.terms_link'),
                },
                {
                    title: this.$t('general.data_processing_agreement'),
                    icon: 'data-processing-agreement',
                    link: this.$t('general.data_processing_link'),
                },
            ],
        };
    },
};
</script>